import { EditorType, resolveEditorCapabilities } from '@wix/a11y-adapters';
import { EditorHost } from '../providers/types';

/**
 * Maps wizard {@link EditorHost} to platform {@link EditorType}.
 * `EditorHost.editor` uses the string `classic-editor`; {@link EditorType.Classic} is `classic`.
 */
export function editorHostToEditorType(editorHost) {
  switch (editorHost) {
    case EditorHost.editor:
      return EditorType.Classic;
    case EditorHost.studio:
      return EditorType.Studio;
    case EditorHost.odeditor:
      return EditorType.OdEditor;
    case EditorHost.studiotwo:
      return EditorType.StudioTwo;
    default:
      {
        throw new Error(`Unsupported editor host for host→type mapping: ${String(editorHost)}`);
      }
  }
}

/** Capabilities for a host; same result as {@link resolveEditorCapabilities} after {@link editorHostToEditorType}. */
export function getEditorCapabilitiesForHost(editorHost) {
  return resolveEditorCapabilities(editorHostToEditorType(editorHost));
}
//# sourceMappingURL=editor-host-to-editor-type.js.map